import { useState } from 'react';
import cn from 'classnames';
import { Modal, ModalContent, ModalFooter } from '@finn-no/troika-react-modal';

import { Image } from '@/components/image/Image';
import { getEnvironmentalCertificate } from './helpers/environmentalCertificates';
import styles from './environmentalCertificate.module.css';

export interface EnvironmentalCertificateProps {
    hotelKey: string;
    className?: string;
}

export const EnvironmentalCertificate = ({ hotelKey, className = '' }: EnvironmentalCertificateProps) => {
    const certificates = getEnvironmentalCertificate(hotelKey);
    const [modalOpen, setModalOpen] = useState(false);
    return certificates.length > 0 ? (
        <div className={`panel panel--neutral ${className}`} data-testid="EnvironmentalCertificate">
            <h3 className="u-t4">Miljøsertifisert hotell</h3>
            <div className="flex flex-align-center">
                <div className={cn(styles.imageContainer, 'image-container image-container-1x1')}>
                    <Image image={certificates[0].logo} altText={certificates[0].name} frame={false} />
                </div>
                <div className={cn(styles.imageText, 'u-d1')}>
                    Dette hotellet er sertifisert med {certificates.map((certificate) => certificate.name).join(' og ')}
                </div>
            </div>
            <button
                type="button"
                data-testid="environmental-certificate-more-button"
                className="button button--small button--link u-pa0 button--link--strong modal-button"
                onClick={() => setModalOpen(true)}>
                Les mer
            </button>
            <Modal isOpen={modalOpen} className="guest-rating-modal" aria-labelledby="environmental-certificate-modal-header">
                <ModalContent>
                    <h2 className="u-t3 u-mt32" id="environmental-certificate-modal-header">
                        Miljøsertifisert hotell
                    </h2>
                    {certificates.map((certificate) => (
                        <div
                            key={certificate.name}
                            data-testid={`certificate-${certificate.name}`}
                            className="certificate-container u-mv16">
                            <div className={cn(styles.certificateImageContainer, 'image-container image-container-1x1')}>
                                <Image image={certificate.logo} altText={certificate.name} frame={false} />
                            </div>
                            <div className="certificate-info">
                                <div className="u-t5 u-mv8">{certificate.name}</div>
                                <div className="u-d1">{certificate.description}</div>
                            </div>
                        </div>
                    ))}
                </ModalContent>
                <ModalFooter className="flex-align-end">
                    <button
                        type="button"
                        data-testid="environmental-certificate-close-button"
                        onClick={() => setModalOpen(false)}
                        className="button flex-no-shrink">
                        Lukk
                    </button>
                </ModalFooter>
            </Modal>
        </div>
    ) : null;
};
